<template>
  <div class="handleFlow">
    <div class="title" style="margin-bottom:20px">办理流程</div>
    <a-steps direction="vertical">
      <a-step status="process" v-for="(item,index) in handleInfo" :key="index">
        <template slot="title">
          <div style="overflow:hidden">
            <span style="float:left;font-size: 20px;color: #1677FF;">{{ item.linkName }}</span>
            <div style="float:right">
              <span>
                <a-tooltip placement="top">
                  <template slot="title">
                    <p>即时：当场完成，直接到下个步骤。</p>
                    <p>n个工作日：最迟n个工作日能够通过此步骤。</p>
                  </template>
                  <span style="font-size: 14px;color: #333333;">时限</span>
                  <a-icon type="question-circle" style="margin-left:5px" />
                </a-tooltip>
                <span style="color:#999;margin-left:10px;font-size:14px">{{ item.handleTerm }}
                  <span v-show="isNumber(item.handleTerm)">工作日</span>
                </span>
              </span>
              <span style="margin-left:15px">
                <span style="font-size: 14px;color: #333333;">审批人:</span>
                <span style="color:#999;margin-left:10px;font-size:14px">{{ item.handlePerson }}</span>
              </span>
            </div>
          </div>
        </template>
        <template slot="description">
          <div style="width: 734px;min-height: 144px;background: #F5F5F5;border-radius: 4px;padding:12px 20px;margin-top:20px;margin-bottom:20px">
            <div>
              <span style="font-size: 16px;color: #333333;font-weight:bold">审批标准</span>
              <p style="font-size: 14px;color: #666666;margin-top:5px">{{ item.handleStandard }}</p>
              <span style="font-size: 16px;color: #333333;font-weight:bold">办理结果</span>
              <p style="font-size: 14px;color: #666666;margin-top:5px">{{ item.handleResult }}</p>
            </div>
          </div>
        </template>
      </a-step>
      <!-- 这个应该不用 -->
      <!-- <a-step status="process">
        <template slot="title">
          <div style="overflow:hidden">
            <span style="float:left;font-size: 20px;color: #1677FF;">受理</span>
            <div style="float:right">
              <span>
                <a-tooltip placement="top">
                  <template slot="title">
                    <p>即时：当场完成，直接到下个步骤。</p>
                    <p>n个工作日：最迟n个工作日能够通过此步骤。</p>
                  </template>
                  <span style="font-size: 14px;color: #333333;">时限</span>
                  <a-icon type="question-circle" style="margin-left:5px" />
                </a-tooltip>
                <span style="color:#999;margin-left:10px;font-size:14px">即时</span>
              </span>
              <span style="margin-left:15px">
                <span style="font-size: 14px;color: #333333;">审批人:</span>
                <span style="color:#999;margin-left:10px;font-size:14px">无</span>
              </span>
            </div>
          </div>
        </template>
        <template slot="description">
          <div style="width: 734px;height: 144px;background: #F5F5F5;border-radius: 4px;padding:12px 20px;margin-top:20px;margin-bottom:20px">
            <div>
              <span style="font-size: 16px;color: #333333;font-weight:bold">审批标准</span>
              <p style="font-size: 14px;color: #666666;margin-top:5px">申请人在线申请事项，需按照事项申报要求填报信息、提交材料。</p>
              <span style="font-size: 16px;color: #333333;font-weight:bold">办理结果</span>
              <p style="font-size: 14px;color: #666666;margin-top:5px">申请人申报成功</p>
            </div>
          </div>
        </template>
      </a-step> -->
    </a-steps>
  </div>
</template>

<script>
export default {
  props: {
    handleInfo: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    }
  },
  methods: {
    isNumber (val) {
      var regPos = /^\d{1,1000000}(\.\d{1,1000000})?$/ // 非负浮点数
      var regNeg = /^(-(([0-9]{1,1000000}\.[0-9]{0,1000000}[1-9][0-9]{0,1000000})|([0-9]{0,1000000}[1-9][0-9]{0,1000000}\.[0-9]+)|([0-9]{0,1000000}[1-9][0-9]{0,1000000})))$/ // 负浮点数
      if (regPos.test(val) || regNeg.test(val)) {
        return true
      } else {
        return false
      }
    }
  }

}
</script>

<style lang="less" scoped>
.handleFlow {
  ::v-deep .ant-steps-item-title {
    display: block;
  }
  .title {
    font-size: 22px;
    color: #333333;
    font-weight: 500;
  }
}
</style>
